module.exports = __webpack_public_path__ + "img/rebate.ebcaafe6.png";